
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactForm from "@/components/contact/ContactForm";
import { Mail } from "lucide-react";

const Contact = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-1">
        <div className="container-custom py-12 md:py-16">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">Contact Us</h1>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Have questions about armpit health or our products? We're here to help. 
              Fill out the form below or reach out through our email.
            </p>
          </div>

          <div className="grid md:grid-cols-1 gap-8 mb-12">
            <div className="bg-card rounded-lg p-6 shadow-sm flex flex-col items-center text-center">
              <div className="bg-primary/10 p-3 rounded-full mb-4">
                <Mail className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-medium mb-2">Email Us</h3>
              <a 
                href="mailto:info@fijidigital.com" 
                className="text-muted-foreground hover:text-primary transition-colors"
                data-ssl-safe="true"
              >
                info@fijidigital.com
              </a>
            </div>
          </div>

          <div className="grid md:grid-cols-5 gap-8">
            <div className="md:col-span-2 bg-card rounded-lg p-6 shadow-sm">
              <h2 className="text-2xl font-semibold mb-4">Get In Touch</h2>
              <p className="text-muted-foreground mb-6">
                Our team of experts is ready to answer your questions about armpit health, 
                product recommendations, or any other inquiries you might have.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <Mail className="h-5 w-5 text-primary mr-3" />
                  <a 
                    href="mailto:info@fijidigital.com" 
                    className="hover:text-primary transition-colors"
                    data-ssl-safe="true"
                  >
                    info@fijidigital.com
                  </a>
                </div>
              </div>
            </div>
            <div className="md:col-span-3">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
